<div class="dialog-container-main confirmation-prompt-popup">
    <div class="dialog-header">
        <h2 mat-dialog-title></h2>
        <button mat-button mat-dialog-close>
            <span class="material-icons">close</span>
        </button>
    </div>
    

    <div class="popup-contnent">
        <div class="form-content-box">
            <h3 class="title">Confirm Deletion </h3>
        <mat-label class="superlabel">{{headline}} You can't undo this action.</mat-label>
        <!-- <mat-label class="superlabel">Do you want to delete this income? </mat-label> -->
    </div>

    <div class="prompt-buttons">
        <button mat-button  class="delete-btn" (click)="onSubmit()">Delete</button>
        <button mat-button class="green" class="cancel-btn" mat-dialog-close>Cancel</button>
    </div>


    <!-- <mat-dialog-actions class="btn-col-footer">
        <button mat-button color="primary" (click)="onSubmit()">Yes</button>
        <button mat-button class="green" mat-dialog-close>No</button>
    </mat-dialog-actions> -->
</div>